<template>
  <div id="app" v-cloak>
    <!-- <XLbackground /> -->
    <canvasView />
    <XLtop />
    <router-view />
    <XLfoot />
  </div>
</template>

<script>
export default {
  data() {},
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped></style>
